<div *ngIf="stagesNavigationService.currentTab && stagesNavigationService.currentTab.showInProgress()"
     class="stages-container">

  <ng-container *ngFor="let group of stagesNavigationService.groups; let isLast = last">

    <div [ngClass]="stagesNavigationService.getGroupStatus(group)" class="group">
      <div class="indicator">{{ group }}</div>
      <div class="label">{{ 'Stages.' + group + '.Title' | translate }}</div>
    </div>

    <div *ngIf="!isLast" class="progress">
      <div [ngStyle]="{'width': stagesNavigationService.getGroupProgress(group) + '%'}"
           class="progress-value"></div>
    </div>

  </ng-container>

  <div class="time-container">
    <img alt="time" src="/img/time.gif">
    <span
      [innerHTML]="'Stages.Time.' + stagesNavigationService.currentTab.stageOutlet  | translate | safe:'html'"></span>
  </div>

</div>

<div class="stages-container-mobile">
  <div class="label">{{
      'Stages.Mobile.Title' | translate: {
        'total': stagesNavigationService.totalGroups,
        'current': stagesNavigationService.currentGroupNumber
      }
    }}
  </div>
  <div class="progress">
    <div [ngStyle]="{'width': stagesNavigationService.overallProgress + '%'}"
         class="progress-value"></div>
  </div>
</div>
